import { ComponentsCustomerType } from "@omni/types/components/customer/shared/customerType.enum";
import { Suspense, useState } from "react";
import { useFormContext } from "react-hook-form";
import { useSelector } from "react-redux";

import { CustomerDetailsFormBlock } from "@/components/Form/RHF/FormBlocks/Customer/customerFormBlock.container";
import { CustomerFormBlockFormValues } from "@/components/Form/RHF/FormBlocks/Customer/customerFormBlock.schema";
import { useThunkDispatch } from "@/redux/dispatcher";
import * as CartSelectors from "@/redux/modules/api/data/cart/cart.selectors";
import * as CustomerModule from "@/redux/modules/api/data/customer/customer.module";
import {
    getCustomer,
    isCustomerFilledIn
} from "@/redux/modules/api/data/customer/customer.selectors";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

import { CheckoutCustomerFormValues } from "../checkoutCustomer.schema";
import { CustomerDetailsModal } from "./components/modal.component";
import { StaticCustomerDetails } from "./components/static.component";

const CheckoutCustomerDetailsContainer = () => {
    const { t } = useGranite();
    const dispatch = useThunkDispatch();

    const { setValues, getValues } =
        useFormContext<CheckoutCustomerFormValues>();

    const isHomeDelivery = useSelector(CartSelectors.hasHomeDelivery);

    const [displayModal, setDisplayModal] = useState(false);
    const customer = useSelector(getCustomer);
    const isFilledInCustomer = useSelector(isCustomerFilledIn);

    const displayEditModal = (show: boolean = true) => setDisplayModal(show);

    const onModalSubmit = async (formObject: CustomerFormBlockFormValues) => {
        const updatedCustomer = {
            ...customer!,
            customerType: formObject.customerType,
            firstName: formObject.firstName,
            lastName: formObject.lastName,
            phone: formObject.phone,
            phonePrefix: formObject.phonePrefix,
            vatNr: formObject.vatInfo?.vatNr,
            companyName: formObject.vatInfo?.companyName,
            vatNrPrefix: formObject.vatInfo?.vatNrPrefix
        };

        const updateCustomerAction = await dispatch(
            CustomerModule.updateFromData(updatedCustomer)
        );

        setValues({
            ...getValues(),
            requestInvoice:
                isHomeDelivery ||
                updatedCustomer.customerType === ComponentsCustomerType.B2B ||
                updatedCustomer.requestInvoice,
            customerType: updatedCustomer.customerType,
            firstName: updatedCustomer.firstName,
            lastName: updatedCustomer.lastName,
            phone: updatedCustomer.phone,
            phonePrefix: updatedCustomer.phonePrefix,
            receiveSms: updatedCustomer.receiveSms
        });

        return updateCustomerAction;
    };

    return (
        <>
            {!isFilledInCustomer && (
                <Suspense fallback={<p>{t("common.loading")}</p>}>
                    <CustomerDetailsFormBlock<CheckoutCustomerFormValues> />
                </Suspense>
            )}
            {isFilledInCustomer && (
                <Suspense fallback={<p>{t("common.loading")}</p>}>
                    <StaticCustomerDetails
                        customer={customer!}
                        onEdit={displayEditModal}
                    />
                    <CustomerDetailsModal
                        customer={customer!}
                        displayModal={displayModal}
                        onDisplayModal={displayEditModal}
                        modalSubmit={onModalSubmit}
                    />
                </Suspense>
            )}
        </>
    );
};

export { CheckoutCustomerDetailsContainer };
